(function () {
  'use strict';

  angular.module('app').component('tourOptionDetail', tourOptionDetail());

  function tourOptionDetail() {
    return {
      bindings: {
        item: '=',
        tourId: '<',
        onTourOptionSaved: '&',
        onUpdatedItemStatus: '&',
        onTourOptionDeleted: '&',
        onTourOptionCanceled: '&',
        defaultLanguage: '<',
        additionalLanguages: '<',
      },
      controller: TourOptionDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/tours/tour-options/tour-option-detail/tour-option-detail.component.html',
    };
  }

  TourOptionDetailComponent.$inject = [
    'CONFIGURATIONS',
    '$filter',
    'UtilService',
    'TourOptionService',
    'TourOptionScheduleService',
  ];

  function TourOptionDetailComponent(
    config,
    $filter,
    UtilService,
    TourOptionService,
    TourOptionScheduleService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    var tourId = null;
    var itemId = null;

    var tourOptionScheduleFieldsDefinition = [
      'departure',
      'duration',
      'duration_timeunit',
      'min_pax_required',
      'max_pax_allowed',
      'cutoff',
      'cutoff_timeunit',
      'is_always_available',
      'base_availability',
    ];

    vm.activeStatus = config.ACTIVE;
    vm.inactiveStatus = config.INACTIVE;

    vm.showMeridian = true;
    vm.timeOptions = config.TIME_OPTIONS;
    vm.hourDisplay = config.HOUR_DISPLAY; // Ex: 01:00 PM

    // Methods
    vm.addTourOptionSchedule = addTourOptionSchedule;
    vm.removeTourOptionSchedule = removeTourOptionSchedule;
    vm.changeTourOptionScheduleStatus = changeTourOptionScheduleStatus;
    vm.deleteTourOptionSchedule = deleteTourOptionSchedule;
    vm.restoreTourOptionSchedules = restoreTourOptionSchedules;
    vm.validateUniqueSchedules = validateUniqueSchedules;
    vm.duplicateSettingSchedules = duplicateSettingSchedules;

    vm.openTourOptionTranslation = openTourOptionTranslation;

    vm.toggleEditMode = toggleEditMode;
    vm.saveTourOption = saveTourOption;
    vm.cancel = cancel;

    vm.$onInit = function () {
      tourId = vm.tourId;
      itemId = vm.item.id;

      if (itemId) {
        // Edit
        vm.editMode = true;

        setTourOptionSchedules(vm.item.tour_option_schedules);

        vm.origDataTourOptionSchedules = angular.copy(vm.item.tour_option_schedules);
      } else {
        // New
        vm.createMode = true;

        vm.item = {
          tour_option_schedules: [],
        };

        addTourOptionSchedule();
      }
    };

    // ----- TOUR OPTION SCHEDULES ----- //
    function setTourOptionSchedules(tour_option_schedules) {
      var orderBy = $filter('orderBy');
      vm.item.tour_option_schedules = orderBy(vm.item.tour_option_schedules, 'departure', false);
    }

    function addTourOptionSchedule() {
      var schedule = {
        editMode: true,
        departure: vm.UtilService.setDurationTime(),
        is_always_available: true,
      };

      vm.item.tour_option_schedules.push(schedule);

      if (vm.item.tour_option_schedules.length > 1) {
        var firstSchedule = vm.item.tour_option_schedules[0];

        vm.duplicateSettingSchedules(firstSchedule);
      }
    }

    function removeTourOptionSchedule(index) {
      vm.item.tour_option_schedules.splice(index, 1);
    }

    function changeTourOptionScheduleStatus(schedule) {
      var successCallback = function (response) {
        vm.onUpdatedItemStatus({ item: response });
      };

      TourOptionScheduleService.changeTourOptionScheduleStatus(
        tourId,
        itemId,
        schedule,
        successCallback
      );
    }

    function deleteTourOptionSchedule(schedule, index) {
      var successCallback = function (index, response) {
        removeTourOptionSchedule(index);
        vm.onTourOptionDeleted({ item: response });
      };

      TourOptionScheduleService.deleteTourOptionSchedule(
        tourId,
        itemId,
        schedule,
        successCallback,
        index
      );
    }

    function restoreTourOptionSchedules() {
      vm.formErrors = false;

      vm.item.tour_option_schedules = angular.copy(vm.origDataTourOptionSchedules);
    }

    function validateUniqueSchedules(scheduleInput) {
      vm.schedulesDuplicated = false;
      var sorted, i, isDuplicate;
      sorted = vm.item.tour_option_schedules.concat().sort(function (a, b) {
        a.dep = $filter('date')(a.departure, 'HH:mm');
        b.dep = $filter('date')(b.departure, 'HH:mm');

        if (a.dep > b.dep) {
          return 1;
        }
        if (a.dep < b.dep) {
          return -1;
        }
        return 0;
      });

      for (i = 0; i < vm.item.tour_option_schedules.length; i++) {
        sorted[i].isDuplicate =
          (sorted[i - 1] && sorted[i - 1].dep === sorted[i].dep) ||
          (sorted[i + 1] && sorted[i + 1].dep === sorted[i].dep);
        if (sorted[i].isDuplicate) {
          vm.schedulesDuplicated = true;
        }
      }

      vm.scheduleInput = scheduleInput;

      vm.duplicateSettingSchedules(scheduleInput);
    }

    function duplicateSettingSchedules(scheduleInput) {
      if (!vm.duplicateOptionValues) {
        return;
      }

      vm.item.tour_option_schedules.forEach(function (schedule) {
        if (schedule.editMode) {
          schedule.duration = scheduleInput.duration;
          schedule.duration_time_unit = scheduleInput.duration_time_unit;
          schedule.min_pax_required = scheduleInput.min_pax_required;
          schedule.max_pax_allowed = scheduleInput.max_pax_allowed;
          schedule.cutoff = scheduleInput.cutoff;
          schedule.cutoff_time_unit = scheduleInput.cutoff_time_unit;
          schedule.is_always_available = scheduleInput.is_always_available;
          schedule.base_availability = scheduleInput.base_availability;
        }
      });
    }

    function toggleEditMode(item) {
      item.editMode = !item.editMode;

      // if item is not in edit mode anymore
      if (!item.editMode) {
        // Undo changes
        _restoreServerValues(item);
      } else {
        // save server name to restore it if the user cancel edition
        item.serverValues = angular.toJson(item);

        item.departure = vm.UtilService.setDurationTime(item.departure);
      }
    }

    // Restore item server values - Edit mode
    function _restoreServerValues(item) {
      var serverItem = angular.fromJson(item.serverValues);

      tourOptionScheduleFieldsDefinition.forEach(function (field) {
        item[field] = serverItem[field];
      });
    }

    function openTourOptionTranslation() {
      TourOptionService.openTourOptionTranslation(tourId, vm.item, vm.additionalLanguages);
    }

    // Create/Update
    function saveTourOption(isFormValid) {
      vm.formErrors = false;

      validateUniqueSchedules(vm.scheduleInput);

      if (!isFormValid || vm.schedulesDuplicated) {
        vm.serverErrors = [];
        vm.formErrors = true;

        return;
      }

      vm.item.tour_option_schedules.forEach(function (schedule) {
        delete schedule.editMode;

        schedule.departure = $filter('date')(schedule.departure, 'HH:mm');
        schedule.tour_id = tourId;
      });

      vm.sendingForm = true;
      TourOptionService.saveTourOption(tourId, vm.item, vm.defaultLanguage).then(function (data) {
        var status = data.status;
        var response = data.response;

        if (status) {
          // Success
          vm.onTourOptionSaved({ item: response });
        } else {
          vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);

          vm.formErrors = true;
        }

        vm.sendingForm = false;
      });
    }

    function cancel() {
      vm.onTourOptionCanceled();
    }
  }
})();
